import gql from 'graphql-tag';

export default gql`
  mutation unPublishContent($id: UUID!) {
    unPublishContent(_id: $id)
  }
`;
